(() => {
  "use strict";
  const configNode = document.getElementById("kaartstudio-test-config");
  if (!configNode) return;
  const config = JSON.parse(configNode.textContent);
  window.__kaartstudioTestOnly = config.checkoutEnabled !== true;
  const cardProducts = window.KaartstudioProducts;
  if (!cardProducts) return;
  /* RESTORED-ARTWORK START */
  const restoredArtwork = {"49795541369166":{"version":"639c3b6b4a81ce1a18a965c0e3483deb343a2a45026fdf159ac64c446e47c6d7"},"55267518021966":{"version":"639c3b6b4a81ce1a18a965c0e3483deb343a2a45026fdf159ac64c446e47c6d7"},"55286135161166":{"version":"639c3b6b4a81ce1a18a965c0e3483deb343a2a45026fdf159ac64c446e47c6d7"},"55327872352590":{"version":"639c3b6b4a81ce1a18a965c0e3483deb343a2a45026fdf159ac64c446e47c6d7"},"59844347625806":{"version":"639c3b6b4a81ce1a18a965c0e3483deb343a2a45026fdf159ac64c446e47c6d7"},"49795541238094":{"version":"2a9b187c41f1bb0ae04a40e05cdda49b0c697057fe7a75b6d7263661487318cf"},"55267518054734":{"version":"2a9b187c41f1bb0ae04a40e05cdda49b0c697057fe7a75b6d7263661487318cf"},"55286135062862":{"version":"2a9b187c41f1bb0ae04a40e05cdda49b0c697057fe7a75b6d7263661487318cf"},"59844347527502":{"version":"2a9b187c41f1bb0ae04a40e05cdda49b0c697057fe7a75b6d7263661487318cf"},"55267555803470":{"version":"7b24b490710d6b5b54aa9d1f48e5869b9842c9e92f48dbeb918af18efdb74cc0"},"55267615998286":{"version":"989c5f34ed560d3be9bd810b916099cf451f07871034740f5b428ce04fce2ebf"},"55267615539534":{"version":"669af9c353c2920355b3b8bc5df9b28c32107702f45709361aa4a122d6fdc901"},"49795541336398":{"version":"786b75327f02fa60afca3f0169a73d7f8ad3a33edf6784d576479c8a368b9f61"},"55267518087502":{"version":"786b75327f02fa60afca3f0169a73d7f8ad3a33edf6784d576479c8a368b9f61"},"55286135193934":{"version":"786b75327f02fa60afca3f0169a73d7f8ad3a33edf6784d576479c8a368b9f61"},"59844347658574":{"version":"786b75327f02fa60afca3f0169a73d7f8ad3a33edf6784d576479c8a368b9f61"},"49795541401934":{"version":"5ca0ff98b41effef745ed06b1fc3d4ee03d0b39ea0e5a5189bc403e830cad123"},"55267518120270":{"version":"5ca0ff98b41effef745ed06b1fc3d4ee03d0b39ea0e5a5189bc403e830cad123"},"55286135456078":{"version":"5ca0ff98b41effef745ed06b1fc3d4ee03d0b39ea0e5a5189bc403e830cad123"},"55327872713038":{"version":"5ca0ff98b41effef745ed06b1fc3d4ee03d0b39ea0e5a5189bc403e830cad123"},"59844347920718":{"version":"5ca0ff98b41effef745ed06b1fc3d4ee03d0b39ea0e5a5189bc403e830cad123"},"49795541172558":{"version":"c2ae66aeefe680254c6bacd8551082a31f4b1ca716e5df315df46b5cad11d9fa"},"55267518153038":{"version":"c2ae66aeefe680254c6bacd8551082a31f4b1ca716e5df315df46b5cad11d9fa"},"55286135554382":{"version":"c2ae66aeefe680254c6bacd8551082a31f4b1ca716e5df315df46b5cad11d9fa"},"49795541270862":{"version":"bb4e6533698a489adcaea7fca976fb326fcaa856ad2c1718bde02df3b418c07f"},"55267518185806":{"version":"bb4e6533698a489adcaea7fca976fb326fcaa856ad2c1718bde02df3b418c07f"},"55286135325006":{"version":"bb4e6533698a489adcaea7fca976fb326fcaa856ad2c1718bde02df3b418c07f"},"49795541434702":{"version":"e5adfed9da1ab32b53d01d7e3a8c0271bc0bbf34e7622d52c00f9c01ab1c5c00"},"55267518218574":{"version":"e5adfed9da1ab32b53d01d7e3a8c0271bc0bbf34e7622d52c00f9c01ab1c5c00"},"55286135587150":{"version":"e5adfed9da1ab32b53d01d7e3a8c0271bc0bbf34e7622d52c00f9c01ab1c5c00"},"49795541467470":{"version":"6ad14967f3a079237e186425c2764eec78a6851c4780432e12cbff4b9c5772d2"},"55267518251342":{"version":"6ad14967f3a079237e186425c2764eec78a6851c4780432e12cbff4b9c5772d2"},"55286135619918":{"version":"6ad14967f3a079237e186425c2764eec78a6851c4780432e12cbff4b9c5772d2"},"49795541500238":{"version":"44346da8c58b1f774e6ebb9b9a9875aad0310c63c0550267bf50269a24963fb3"},"55267518284110":{"version":"44346da8c58b1f774e6ebb9b9a9875aad0310c63c0550267bf50269a24963fb3"},"55286135652686":{"version":"44346da8c58b1f774e6ebb9b9a9875aad0310c63c0550267bf50269a24963fb3"},"49795541533006":{"version":"d4758abe4d975b008d8172f86dc7c228819ee64a695474922d53a1417f9768ed"},"55267518316878":{"version":"d4758abe4d975b008d8172f86dc7c228819ee64a695474922d53a1417f9768ed"},"55286135685454":{"version":"d4758abe4d975b008d8172f86dc7c228819ee64a695474922d53a1417f9768ed"},"49795541565774":{"version":"26b73335ed1413db268750269416d19bbd7a3ac161f3c03a982f5c7898e2808d"},"55267518349646":{"version":"26b73335ed1413db268750269416d19bbd7a3ac161f3c03a982f5c7898e2808d"},"55286135718222":{"version":"26b73335ed1413db268750269416d19bbd7a3ac161f3c03a982f5c7898e2808d"},"49795541598542":{"version":"62c5b9ab5497b5fccb094875ca5c072ae4929eb218eff943b90ed962a6bfa80c"},"55267518382414":{"version":"62c5b9ab5497b5fccb094875ca5c072ae4929eb218eff943b90ed962a6bfa80c"},"55286135750990":{"version":"62c5b9ab5497b5fccb094875ca5c072ae4929eb218eff943b90ed962a6bfa80c"},"49795541631310":{"version":"6d35d879cb7d8f521c0106d109fa1d04aefd777a23f3e1a85181545e79b9de32"},"55267518415182":{"version":"6d35d879cb7d8f521c0106d109fa1d04aefd777a23f3e1a85181545e79b9de32"},"55286135783758":{"version":"6d35d879cb7d8f521c0106d109fa1d04aefd777a23f3e1a85181545e79b9de32"},"49795541303630":{"version":"558c759f37cfed275033a6cdf149ad102624cda580b0d720e10cff9b1eba09d3"},"55267518447950":{"version":"558c759f37cfed275033a6cdf149ad102624cda580b0d720e10cff9b1eba09d3"},"55286135816526":{"version":"558c759f37cfed275033a6cdf149ad102624cda580b0d720e10cff9b1eba09d3"},"49795541205326":{"version":"29dbce23649879458c189c7bd1204679fd10c50dc3e106f2c2b98713310839f2"},"55267518480718":{"version":"29dbce23649879458c189c7bd1204679fd10c50dc3e106f2c2b98713310839f2"},"55286135849294":{"version":"29dbce23649879458c189c7bd1204679fd10c50dc3e106f2c2b98713310839f2"},"55267571237198":{"version":"cc1dac931f7fd81cac30019acf8de8fb9ddff5558b6cd7f17603c73b2e794428"},"55267569140046":{"version":"393b0b8c95e124cf02e6b418cbfe93f1a1144c497c7c833edad3ef80c2b53b81"},"55267617571150":{"version":"69a90fe6023ec2d91b577124cbaefb7e51e82fedfb25fb3e37380e49879b21b1"},"55267536601422":{"version":"7b9b9652b4bf47d249430fc900249890c63b9984ff652e4137a7c766e966e6ed"},"55267557572942":{"version":"c800eeec2e36800e3345ec92832756081497ed0b96bd9d6b9067513fa8a3ded2"},"55267534897486":{"version":"2c28e8258b85c5d0f1f55224e71210ede73709aab0c81805ec9eefc8facf1b63"},"55267578151246":{"version":"be256dba9ea21e8e18fbcf84c9fd98fb971530e249c242810f1ead59583de13f"},"55267617309006":{"version":"65022c4d34d88d5d6e59c19697db4cd1f7e63af1086e82093fe8bfb4cc407af3"},"55267538436430":{"version":"a4e76e9a1c7bbf49e60f49818c297adadb716d72e7ff01c3967aaa8708de9ecd"},"55267614851406":{"version":"0a1e21f05ca9a17da28f3f69f9dc4307a5dca572f0fcf3ae3114470c9423235c"},"55267562029390":{"version":"47240965d5d3f20ef631b49e059d546cb5984d783880e95dd3c934ce462f6b13"},"55267616489806":{"version":"fb7210295c3a47f78f5610a7f7b9bf762d9788d93f7164ca087974b376364c28"},"55267563012430":{"version":"c2ee748eeae3ef107397704dca65022600cda18087678b8fd9097fa7315edba7"},"55286135128398":{"version":"a06f2dce8d56393fb6c3fd91162678ab0d444274abf3d31756d69d34f85d456a"},"60986053493070":{"version":"a06f2dce8d56393fb6c3fd91162678ab0d444274abf3d31756d69d34f85d456a"},"60986053525838":{"version":"a06f2dce8d56393fb6c3fd91162678ab0d444274abf3d31756d69d34f85d456a"},"60986053558606":{"version":"a06f2dce8d56393fb6c3fd91162678ab0d444274abf3d31756d69d34f85d456a"},"55286135488846":{"version":"dadb865e2f3c8dec6bfa70f691222c12ac6ba779f246a90ff55384f9c1fa42dd"},"60986053591374":{"version":"dadb865e2f3c8dec6bfa70f691222c12ac6ba779f246a90ff55384f9c1fa42dd"},"60986053624142":{"version":"dadb865e2f3c8dec6bfa70f691222c12ac6ba779f246a90ff55384f9c1fa42dd"},"60986053656910":{"version":"dadb865e2f3c8dec6bfa70f691222c12ac6ba779f246a90ff55384f9c1fa42dd"},"55286135095630":{"version":"63da1aa354bac254137e0c306acca3eecb5a1c20065fa22022c80b71b5b618b6"},"60986053722446":{"version":"63da1aa354bac254137e0c306acca3eecb5a1c20065fa22022c80b71b5b618b6"},"60986053755214":{"version":"63da1aa354bac254137e0c306acca3eecb5a1c20065fa22022c80b71b5b618b6"},"60986053787982":{"version":"63da1aa354bac254137e0c306acca3eecb5a1c20065fa22022c80b71b5b618b6"},"55286135521614":{"version":"a7c078be4cf9d5bb83442f30e08b6e74dce0d1b752ac473f7810f8f6fca19aa0"},"55286135226702":{"version":"b5074d2dde9558d233b9bdf3dcde85a9c84c80add36b9088c7405d66ac27723e"},"55286134899022":{"version":"f5bf62b92a015c39643be5b5893ad739b450fb8fdb85f0df2df29a00196daed7"},"55286135030094":{"version":"fa5058e2480d50e2f14f34a819f1f30dfae072e7aff6544fd314b0f43507dffc"},"55286135390542":{"version":"68e14dfad3a0bfb2195f9967f30bcb81b0e1e3ce7622d72114781aabd74039dd"},"55286134964558":{"version":"2bf96305ce2d4bef024e555a1fd89837480662db8c7640be37f2fb9d49b3332f"},"55286135357774":{"version":"610e7dc433b19b3bcda1aba2cb61e749cbe512db57a4255b60b5aa3fb78d42c8"},"55286135292238":{"version":"8b31238499cdeb588f4baba3a65d683d11cf4e66910247b45dbe186d8cecf711"},"59844347429198":{"version":"cc1dac931f7fd81cac30019acf8de8fb9ddff5558b6cd7f17603c73b2e794428"},"55286134931790":{"version":"247f18b32ec216c49d6e1f45d586168b9112bdcc4532f5fbdac3c83594305ef5"},"55286134997326":{"version":"3f0442bae43922f801d50b54f7067d4bf751114c52874ab917a416e45ceba73c"},"55286135259470":{"version":"71f041678b42c07077ebf23507bcb46d6470889c50fefaf60af6855eccf55e96"},"55286134866254":{"version":"09ee6c0fa0cf7e441beadc94ad264602d0017e7ef3d63b0c07383014c5a89cc4"},"55286135423310":{"version":"a8bc3276844e8e6542638a074486e0f3efd2b0d632b0d524a5816377d4200e55"},"55327872057678":{"version":"23e0386bbb7ff5dd4c5db9258888f6624fe3534032bb27848b75114bdc6fbf42"},"55327872155982":{"version":"a2374d6aec2716ea5158c95449dcdf34ad4e27110b305f0b5823fea160596684"},"55327872090446":{"version":"9e01ee10c9b26297289cbf6262e8066c77c5e371052248caccc0fe4d1acdae1e"},"55327872123214":{"version":"1aa90ce7b477b6e46e4ece7a7db572d35420548ea79309334fc6478aa6992140"},"55327872188750":{"version":"4fede97646e08e605bdcfe8f17cf15faeedc1bb354d3d81b7886df952ebc56f2"},"55327872221518":{"version":"64980beac7fc6ae663c6772b23a5f120b9813a1f4d6473c59816b7dd21b09521"},"55327872254286":{"version":"34437e920c7857fa58f4986086b26a64035527d6b3fa3fd860cd04d26c523ab1"},"55327872287054":{"version":"9730001dda238986dd94d0c51afd08ab88e4fd58d3bc4498f74e5a4f536dec91"},"55327872319822":{"version":"a9ea881fea847f00f4af4b82ee603e05d211a31910f140d67323d7028861699f"},"55327872385358":{"version":"286dc7879837267c86c7858f97c32262f2077b2019b50ac4c6d1d4c935e25a45"},"59844347396430":{"version":"d886254d297a9f766797453e5eea8ea64fd0d76dfd002479146bd30ccac5ab81"},"59844347330894":{"version":"897a7eb9cf06e854183ce9ed4940fb959ab763590fadb2f564de80ab5c813b59"},"59844347593038":{"version":"176514380bdab0795d8537ffb2640fb9a12eb390cd174bb8a8d43ad51c33a4da"},"59844347363662":{"version":"7e531699cac342e39ad9ba157c4ff2a127d5e1a38aec7fbf45221bb77729b2f1"},"59844347494734":{"version":"62217989d964b9c19dde41eab0e0e0267bbe3fbb4ac4803457c28ca7e8ae78b5"},"59844347461966":{"version":"c815d548ebcfc3d155ca3da8a171b3410aa97c9e6484ce6a098045d3fa099e87"},"59844347691342":{"version":"f684eea3676b78f81469c99d4cf0347e586f605b02e8264fe8cacf5d447062e4"},"59844347560270":{"version":"af9cb342ee7dc4d7b18d9fda3794509682f1713a676eedd215c111ffe2e756cb"}};
  /* RESTORED-ARTWORK END */
  function upgradeCardImages() {
    document.querySelectorAll('addon-section .addon-section--tab[data-index="0"] .addon-section__tab--product').forEach(card => {
      const id = card.querySelector('input[name="id"]')?.value;
      const artwork = cardProducts.resolve(id) || restoredArtwork[id];
      const image = card.querySelector('.addon-section__tab--product-image img');
      if (!artwork?.version || !image || image.dataset.artworkVersion === artwork.version) return;
      const base = new URL('/catalog-artwork/' + artwork.version, config.origin).href;
      image.dataset.artworkVersion = artwork.version;
      image.srcset = base + '-512.webp 1x, ' + base + '-1024.webp 2x';
      image.src = base + '-512.webp';
      image.decoding = 'async';
      card.dataset.imgSrc = image.src;
      card.dataset.front = base + '-full.webp';
      const zoom = card.querySelector('.js-rao-global-trigger');
      if (zoom) zoom.dataset.front = card.dataset.front;
    });
  }
  let artworkFrame = 0;
  const artworkObserver = new MutationObserver(() => {
    if (!artworkFrame) artworkFrame = requestAnimationFrame(() => {
      artworkFrame = 0;
      upgradeCardImages();
    });
  });
  artworkObserver.observe(document.documentElement, {childList:true, subtree:true});
  upgradeCardImages();
  const checkoutRequest = (url) => {
    if (config.checkoutEnabled === true) return false;
    try {
      const u = new URL(url, location.origin);
      return (
        u.origin === location.origin &&
        /\/checkout(?:[/?]|$)/.test(
          u.pathname,
        )
      );
    } catch {
      return false;
    }
  };
  const blocked = () => new Error(config.blocked);
  const originalFetch = window.fetch;
  window.fetch = function (input, init) {
    const url =
      typeof input === "string"
        ? input
        : input instanceof URL
          ? input.href
          : input.url;
    if (checkoutRequest(url)) return Promise.reject(blocked());
    return originalFetch.apply(this, arguments);
  };
  const originalOpen = XMLHttpRequest.prototype.open,
    originalSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function (method, url) {
    this.__kaartstudioBlocked = checkoutRequest(url);
    return originalOpen.apply(this, arguments);
  };
  XMLHttpRequest.prototype.send = function () {
    if (this.__kaartstudioBlocked) throw blocked();
    return originalSend.apply(this, arguments);
  };
  let overlay,
    frame,
    activeWizard,
    activeTemplate,
    completed,
    cartTarget,
    cartSaving = false,
    cardDrafts = new Map();
  const storageKey = "kaartstudio-wizard-test-v1";
  try {
    const stored = JSON.parse(sessionStorage.getItem(storageKey) || "{}");
    cardDrafts = new Map(Object.entries(stored));
  } catch {}
  function rememberCards() {
    try { sessionStorage.setItem(storageKey, JSON.stringify(Object.fromEntries(cardDrafts))); } catch {}
  }
  // The parent owns every wizard entry, including the screens inside the iframe.
  // Traversal restores a screen; it must never push another history entry.
  function cardRoute(state = history.state) {
    const route = state?.kaartstudio;
    return state?.step === 0 && state.textActive === true && route?.version === 1 &&
      /^\d+$/.test(route.templateId) && ["size", "edit", "review"].includes(route.screen)
      ? route : null;
  }
  function rememberScreen(screen, replace = false) {
    if (!activeWizard || cartTarget || !activeTemplate) return;
    const previous = cardRoute();
    const route = {version:1, templateId:activeTemplate, screen,
      format:sizeChoice?.format || cardDrafts.get(activeTemplate)?.format || "A5"};
    const method = replace || previous?.templateId === activeTemplate && previous.screen === screen
      ? "replaceState" : "pushState";
    history[method]({...history.state, step:0, textActive:true, kaartstudio:route}, "");
    activeWizard.saveReturnState();
  }
  let backPending = false;
  window.addEventListener("popstate", () => { backPending = false; });
  function previousCardScreen() {
    if (cardRoute()) {
      if (backPending) return;
      backPending = true;
      history.back();
      // Also recover if an externally restored history has no previous entry.
      setTimeout(() => { backPending = false; }, 1000);
    } else {
      close();
      activeWizard?.goToStep(0, false);
    }
  }
  let forwardConfirmation = null;
  const cardGridViews = new WeakMap();
  let pendingGridReturn = null;
  function syncFrameNavigation() {
    const route = cardRoute();
    if (!route || cartTarget || overlay?.hidden || frame?.dataset.ready !== "true" ||
        route.templateId !== frame.dataset.templateId) return;
    const confirm = route.screen === "review" && forwardConfirmation === route.templateId;
    if (confirm) forwardConfirmation = null;
    frame.contentWindow.postMessage({type:"ballonnenshop:kaart-navigeren", confirm,
      screen:route.screen, face:route.face === 0 ? 0 : undefined, navigationId:frame.dataset.navigationId,
      loadId:frame.dataset.loadId}, config.origin);
  }
  // Keep the same iframe alive when promoting the editor into the top layer.
  // Reparenting an iframe would reload it and discard unsaved input.
  let mountSection, loading, loadingText, loadingRetry, loadingTimer;
  let sizePopup, sizeChoice = null, choiceTimer;
  const portraitTemplate = document.getElementById("kaartstudio-person-template");
  const portraitReady = new Map();
  // Preload the public preview photos before a customer opens the chooser.
  // The already-loaded card stays visible if a photo is unavailable.
  portraitTemplate?.content.querySelectorAll("[data-person-photo]").forEach(node => {
    const image = new Image();
    image.fetchPriority = "low";
    image.src = node.getAttribute("href");
    portraitReady.set(node.closest("[data-portrait]").dataset.portrait,
      image.decode().then(() => true).catch(() => false));
  });
  function updatePortrait() {
    if (!sizeChoice) return;
    const scene = sizePopup.querySelector(".bs-size-portraits");
    if (!scene) return;
    const format = sizeChoice.format;
    const gallery = scene.closest('.bs-size-gallery');
    if (scene.dataset.format !== format) setPreviewView(gallery, 'hand');
    scene.dataset.format = format;
    portraitReady.get(format)?.then(ready => {
      if (!ready || scene.dataset.format !== format || !scene.isConnected) return;
      scene.dataset.photo = format;
      scene.dataset.ready = "true";
      gallery.dataset.photo = format;
    });
  }
  function setPreviewView(gallery, view) {
    gallery.querySelector('.bs-size-portraits').dataset.view = view;
    const navigation = gallery.querySelector('[data-preview-nav]');
    if (navigation) {
      navigation.dataset.direction = view === 'envelope' ? 'previous' : 'next';
      navigation.setAttribute('aria-label', view === 'envelope'
        ? 'Bekijk de kaart in de hand' : 'Bekijk de kaart met envelop');
    }
    gallery.querySelectorAll('[data-preview-view]').forEach(button => {
      button.setAttribute('aria-pressed', String(button.dataset.previewView === view));
    });
  }
  function updateChoice() {
    if (!sizeChoice) return;
    updatePortrait();
    sizePopup.querySelectorAll("[data-size]").forEach(button => {
      button.setAttribute("aria-pressed", String(button.dataset.size === sizeChoice.format));
      button.disabled = sizeChoice.pending;
    });
    const button = sizePopup.querySelector(".kaartstudio-personalise");
    button.disabled = sizeChoice.pending;
    button.setAttribute("aria-busy", String(sizeChoice.pending));
    button.querySelectorAll("[data-size-action-label]").forEach(label => {
      label.textContent = sizeChoice.pending ? sizePopup.dataset.opening :
        sizeChoice.failed ? sizePopup.dataset.retry : label.dataset.label;
    });
    sizePopup.querySelector(".kaartstudio-size-error").hidden = !sizeChoice.failed;
    if (cardRoute()?.screen === "size") rememberScreen("size", true);
    else activeWizard?.saveReturnState();
  }
  function sendChoice() {
    if (!sizeChoice?.pending || sizeChoice.sent || frame.dataset.ready !== "true") return;
    sizeChoice.sent = true;
    frame.contentWindow.postMessage({type:"ballonnenshop:personaliseer", format:sizeChoice.format,
      loadId:frame.dataset.loadId}, config.origin);
  }
  function choiceFailed(reload = false) {
    if (!sizeChoice || overlay.hidden) return;
    clearTimeout(choiceTimer);
    sizeChoice.pending = false;
    sizeChoice.sent = false;
    sizeChoice.failed = true;
    sizeChoice.reload = reload;
    updateChoice();
    loading.hidden = true;
    sizePopup.hidden = false;
    overlay.classList.add("has-size-popup");
    overlay.removeAttribute("aria-busy");
    fullscreen(false);
    sizePopup.querySelector(".kaartstudio-personalise").focus({preventScroll:true});
  }
  function personalise() {
    if (!sizeChoice || sizeChoice.pending) return;
    const choice = sizeChoice;
    if (choice.reload || frame.dataset.ready !== "true" && choice.failed) {
      const path = frame.dataset.path;
      frame.dataset.path = "";
      open(path, choice);
    }
    choice.pending = true;
    choice.failed = false;
    choice.reload = false;
    choice.sent = false;
    updateChoice();
    sizePopup.hidden = true;
    overlay.classList.remove("has-size-popup");
    overlay.setAttribute("aria-busy", "true");
    loading.hidden = false;
    loadingRetry.hidden = true;
    loading.dataset.failed = "false";
    loading.setAttribute("role", "status");
    loadingText.textContent = "Nog heel even…";
    fullscreen(true);
    loading.focus({preventScroll:true});
    clearTimeout(choiceTimer);
    choiceTimer = setTimeout(() => choiceFailed(true), 45000);
    sendChoice();
  }
  function fit() {
    if (!overlay || overlay.hidden || document.hidden) return;
    const style = (name, value) => { if (overlay.style[name] !== value) overlay.style[name] = value; };
    const viewport = window.visualViewport;
    if (viewport && viewport.scale > 1.05) return;
    if (overlay.dataset.fullscreen === "true") {
      style("maxHeight", "none");
      style("height", (viewport?.height || innerHeight) + "px");
      style("top", (viewport?.offsetTop || 0) + "px");
      return;
    }
    const height = viewport?.height || innerHeight;
    const gap = innerWidth < 700 ? 12 : 24;
    if (sizeChoice && innerWidth < 700) {
      const available = Math.max(0, height - gap * 2) + "px";
      if (overlay.style.getPropertyValue("--kaartstudio-available-height") !== available)
        overlay.style.setProperty("--kaartstudio-available-height", available);
      style("height", "auto");
      style("maxHeight", available);
      const popupHeight = overlay.getBoundingClientRect().height;
      style("top", ((viewport?.offsetTop || 0) + (height - popupHeight) / 2) + "px");
      return;
    }
    style("maxHeight", "none");
    const popupHeight = Math.min(sizeChoice ? 620 : cartTarget ? 760 : 700, height - gap * 2) - (sizeChoice ? 62 : 0);
    style("height", popupHeight + "px");
    style("top", ((viewport?.offsetTop || 0) + (height - popupHeight) / 2) + "px");
  }
  window.addEventListener("resize", fit);
  window.visualViewport?.addEventListener("resize", fit);
  window.visualViewport?.addEventListener("scroll", fit);
  let viewportRecoveryTimers = [];
  function stopViewportRecovery() {
    viewportRecoveryTimers.forEach(clearTimeout);
    viewportRecoveryTimers = [];
  }
  function recoverViewport() {
    stopViewportRecovery();
    if (document.hidden || !overlay || overlay.hidden) return;
    fit();
    // Returning from iOS sharing/mail may not emit resize; the viewport can
    // settle after visibility/pageshow. Refit the existing iframe, never reload.
    viewportRecoveryTimers = [100, 350, 1000].map(delay => setTimeout(fit, delay));
  }
  document.addEventListener("visibilitychange", recoverViewport);
  window.addEventListener("pageshow", recoverViewport);
  window.addEventListener("focus", recoverViewport);
  window.addEventListener("orientationchange", recoverViewport);
  window.addEventListener("pagehide", stopViewportRecovery);
  function fullscreen(enabled) {
    if (!overlay) return;
    overlay.dataset.fullscreen = String(enabled);
    if (!overlay.hidden) {
      document.body.classList.toggle("kaartstudio-fullscreen", enabled);
      mountSection?.classList.toggle("kaartstudio-editing", enabled);
      if (!enabled && activeWizard) {
        activeWizard.tabs[0]?.classList.remove("wizard-state-text");
        activeWizard.tabs[0]?.classList.add("wizard-state-cards");
      }
      fit();
      if (!overlay.open) overlay.showModal();
    }
    fit();
  }
  function close() {
    stopViewportRecovery();
    clearTimeout(loadingTimer);
    clearTimeout(choiceTimer);
    if (sizeChoice?.pending) frame.dataset.path = "";
    sizeChoice = null;
    if (overlay?.classList.contains("is-loading") || cartTarget) frame.dataset.path = "";
    if (overlay) {
      overlay.close();
      overlay.hidden = true;
    }
    mountSection?.classList.remove("kaartstudio-editing");
    document.body.classList.remove("kaartstudio-open", "kaartstudio-fullscreen");
  }
  function open(path, choice = null) {
    let nextFrameUrl;
    const section =
      activeWizard?.closest(".addon-section--section") ||
      document.querySelector(".addon-section--section");
    if (!overlay) {
      overlay = document.createElement("dialog");
      overlay.setAttribute("aria-label", "Je kaart persoonlijk maken");
      overlay.addEventListener("cancel", (event) => {
        event.preventDefault();
        if (sizeChoice || overlay.classList.contains("is-loading")) {
          previousCardScreen();
          return;
        }
        frame.contentWindow.postMessage(
          { type: "ballonnenshop:afsluiten" },
          config.origin,
        );
      });
      let startedOnSizeBackdrop = false;
      const isSizeBackdrop = (event) => {
        if (!sizeChoice || sizeChoice.pending || sizePopup.hidden ||
            !overlay.open || event.target !== overlay) return false;
        const bounds = overlay.getBoundingClientRect();
        return event.clientX < bounds.left || event.clientX > bounds.right ||
          event.clientY < bounds.top || event.clientY > bounds.bottom;
      };
      overlay.addEventListener("pointerdown", (event) => {
        startedOnSizeBackdrop = event.isPrimary && event.button === 0 && isSizeBackdrop(event);
      });
      overlay.addEventListener("pointercancel", () => { startedOnSizeBackdrop = false; });
      overlay.addEventListener("click", (event) => {
        const dismiss = startedOnSizeBackdrop && isSizeBackdrop(event);
        startedOnSizeBackdrop = false;
        if (!dismiss) return;
        event.preventDefault();
        event.stopPropagation();
        previousCardScreen();
      });
      overlay.className = "kaartstudio-mount";
      frame = document.createElement("iframe");
      frame.title = "Je kaart persoonlijk maken";
      frame.allow = "clipboard-write; microphone https://kaarten.ballonnenshop.nl";
      frame.addEventListener("load", fit);
      loading = document.createElement("div");
      loading.className = "kaartstudio-loading bs-card-loading";
      loading.setAttribute("role", "status");
      loading.setAttribute("aria-label", "Je kaart wordt geladen");
      loading.tabIndex = -1;
      const spinner = document.createElement("span");
      spinner.className = "bs-loading-spinner";
      spinner.setAttribute("aria-hidden", "true");
      const title = document.createElement("strong");
      title.textContent = "Je kaart kon nog niet worden geopend";
      loadingText = document.createElement("p");
      loadingRetry = document.createElement("button");
      loadingRetry.type = "button";
      loadingRetry.className = "boot-retry";
      loadingRetry.textContent = "Opnieuw proberen";
      loadingRetry.addEventListener("click", () => {
        if (sizeChoice) { choiceFailed(true); return; }
        const path = frame.dataset.path;
        frame.dataset.path = "";
        open(path);
      });
      const loadingClose = document.createElement("button");
      loadingClose.type = "button";
      loadingClose.className = "bs-loading-close";
      loadingClose.textContent = config.close;
      loadingClose.addEventListener("click", () => {
        previousCardScreen();
      });
      const artwork = document.getElementById("kaartstudio-loading-template").content.cloneNode(true);
      const copy = document.createElement("div");
      copy.className = "bs-loading-copy";
      copy.append(title, loadingText);
      loading.append(artwork, copy, spinner, loadingRetry, loadingClose);
      sizePopup = document.getElementById("kaartstudio-size-template").content.firstElementChild.cloneNode(true);
      sizePopup.hidden = true;
      const personaliseButton = sizePopup.querySelector(".kaartstudio-personalise");
      personaliseButton.querySelectorAll("[data-size-action-label]").forEach(label => {
        label.dataset.label = label.textContent;
      });
      personaliseButton.addEventListener("click", personalise);
      sizePopup.querySelector("[data-size-close]").addEventListener("click", () => {
        previousCardScreen();
      });
      sizePopup.querySelectorAll("[data-size]").forEach(button => button.addEventListener("click", () => {
        if (!sizeChoice || sizeChoice.pending) return;
        sizeChoice.format = button.dataset.size;
        updateChoice();
      }));
      overlay.append(sizePopup, loading);
      new ResizeObserver(fit).observe(sizePopup);
    }
    if (section) {
      mountSection = section;
      const container = section.querySelector(":scope > .container");
      if (overlay.parentElement !== container) container.append(overlay);
    } else {
      mountSection = document.querySelector("#main");
      if (overlay.parentElement !== mountSection) mountSection.append(overlay);
    }
    sizeChoice = choice;
    sizePopup.hidden = !choice;
    overlay.classList.toggle("has-size-popup", !!choice);
    frame.inert = !!choice;
    if (choice) {
      const preview = sizePopup.querySelector(".kaartstudio-size-preview");
      if (preview.dataset.src !== choice.image) {
        const img = new Image();
        img.src = choice.image;
        img.alt = choice.title;
        img.loading = "eager";
        img.decoding = "sync";
        const paper = document.createElement("div");
        paper.className = "kaartstudio-folded-card kaartstudio-size-paper";
        paper.style.setProperty("--kaartstudio-preview-ratio", choice.ratio);
        paper.append(img);
        if (portraitTemplate) {
          const scene = portraitTemplate.content.firstElementChild.cloneNode(true);
          scene.querySelectorAll('[data-preview-view]').forEach(button => {
            button.addEventListener('click', () => setPreviewView(scene, button.dataset.previewView));
          });
          scene.querySelector('[data-preview-nav]')?.addEventListener('click', () => {
            const current = scene.querySelector('.bs-size-portraits').dataset.view;
            setPreviewView(scene, current === 'envelope' ? 'hand' : 'envelope');
          });
          portraitReady.get('envelope')?.then(ready => {
            if (ready) scene.querySelectorAll('[data-preview-view="envelope"], [data-preview-nav]').forEach(button => { button.disabled = false; });
          });
          scene.querySelector(".bs-size-fallback").append(paper);
          scene.querySelectorAll("[data-card-design]").forEach(node => node.setAttribute("href", choice.image));
          // Project the complete portrait artwork onto the photographed paper.
          // Its measured bounds differ slightly from ISO paper ratios; `meet`
          // exposes the blank prop along the sides, especially in the XL photo.
          // Keep substantially different (e.g. landscape) designs contained.
          const fitArtwork = ratio => {
            scene.querySelectorAll("[data-card-design]").forEach(node => {
              const paperRatio = Number(node.getAttribute("width")) / Number(node.getAttribute("height"));
              node.setAttribute("preserveAspectRatio",
                Math.abs(ratio / paperRatio - 1) <= 0.03 ? "none" : "xMidYMid meet");
            });
          };
          fitArtwork(img.naturalWidth && img.naturalHeight ? img.naturalWidth / img.naturalHeight : choice.ratio);
          img.addEventListener("load", () => fitArtwork(img.naturalWidth / img.naturalHeight), {once:true});
          preview.replaceChildren(scene);
        } else preview.replaceChildren(paper);
        preview.dataset.src = choice.image;
      }
      updateChoice();
      frame.setAttribute("aria-hidden", "true");
    }
    if (frame.dataset.path !== path) {
      frame.dataset.resuming = String(new URL(path, config.origin).searchParams.get("resume") === "1");
      frame.dataset.stage = cartTarget ? "review" : frame.dataset.resuming === "true" ? "edit" : "size";
      frame.dataset.ready = "false";
      clearTimeout(loadingTimer);
      frame.dataset.path = path;
      frame.dataset.loadId = crypto.randomUUID();
      const url = new URL(path, config.origin);
      url.searchParams.set("_load", frame.dataset.loadId);
      overlay.classList.add("is-loading");
      overlay.setAttribute("aria-busy", "true");
      frame.setAttribute("aria-hidden", "true");
      loading.hidden = !!choice;
      loadingRetry.hidden = true;
      loading.dataset.failed = "false";
      loading.setAttribute("role", "status");
      loadingText.textContent = "Nog heel even…";
      loadingTimer = setTimeout(() => {
        loadingText.textContent =
          "Het duurt iets langer. Je kunt opnieuw proberen.";
        loadingRetry.hidden = false;
        loading.dataset.failed = "true";
        loading.setAttribute("role", "alert");
      }, 45000);
      nextFrameUrl = url.href;
    }
    overlay.hidden = false;
    document.body.classList.add("kaartstudio-open");
    fullscreen(!choice && (cartTarget ? frame.dataset.stage === "edit" : frame.dataset.stage !== "size"));
    if (choice) {
      overlay.removeAttribute("aria-busy");
      sizePopup.querySelector("[data-size-close]").focus({preventScroll:true});
    } else if (frame.dataset.ready === "true") {
      loading.hidden = true;
      overlay.removeAttribute("aria-busy");
      frame.removeAttribute("aria-hidden");
    }
    fit();
    requestAnimationFrame(() => requestAnimationFrame(fit));
    if (nextFrameUrl) {
      const loadId = frame.dataset.loadId;
      const navigate = () => {
        if (!overlay.hidden && frame.dataset.loadId === loadId) {
          if (!frame.isConnected) overlay.append(frame);
          // Replacing the iframe document avoids invisible browser Back stops.
          frame.contentWindow.location.replace(nextFrameUrl);
        }
      };
      if (choice) requestAnimationFrame(() => requestAnimationFrame(() => setTimeout(navigate, 0)));
      else navigate();
    }
  }
  function openStudio(wizard) {
    cartTarget = null;
    activeWizard = wizard;
    const route = cardRoute();
    let selected = wizard.tabs[0]?.querySelector(
      ".addon-section__tab--product.selected",
    );
    if (route && selected?.querySelector('input[name="id"]')?.value !== route.templateId) {
      const historical = Array.from(wizard.tabs[0]?.querySelectorAll(".addon-section__tab--product") || [])
        .find(card => card.querySelector('input[name="id"]')?.value === route.templateId);
      if (historical) {
        selected?.classList.remove("selected");
        historical.classList.add("selected");
        wizard.addProductToCart(wizard.tabs[0], historical);
        selected = historical;
      }
    }
    const id = selected?.querySelector('input[name="id"]')?.value;
    if (!id || !cardProducts.resolve(id)) {
      // The selected card may have disappeared from the catalogue since the
      // snapshot. Return to the card choices instead of an empty text step.
      wizard.isTextStepActive = false;
      history.replaceState({...history.state, step:0, textActive:false}, "");
      wizard.updateWizardUI();
      return;
    }
    activeTemplate = id;
    const saved = cardDrafts.get(id),
      params = new URLSearchParams({ parent: location.origin, template: cardProducts.resolve(id).templateId, chooser:"parent", navigation:"parent" });
    const resume = wizard.kaartstudioResume;
    delete wizard.kaartstudioResume;
    if (saved?.draftId) params.set("draft", saved.draftId);
    params.set("balloon", String(config.balloonTitle || "").slice(0, 300));
    params.set("balloonTags", (Array.isArray(config.balloonTags) ? config.balloonTags : []).join("|").slice(0, 2000));
    const screen = route?.templateId === id ? route.screen :
      resume?.templateId === id && ["edit", "review"].includes(resume.screen) && saved?.draftId ? resume.screen : "size";
    if (!route) rememberScreen(screen, true);
    params.set("view", screen);
    if (screen !== "size" && saved?.draftId) params.set("resume", "1");
    const reuse = frame?.dataset.templateId === id && frame.dataset.path;
    const path = reuse ? frame.dataset.path : "/studio?" + params;
    if (screen !== "size") {
      open(path);
      frame.dataset.templateId = id;
      frame.dataset.navigationId = crypto.randomUUID();
      frame.dataset.stage = screen;
      fullscreen(true);
      syncFrameNavigation();
      return;
    }
    const image = selected.querySelector(".addon-section__tab--product-image img");
    const restoredFormat = route?.format || (resume?.templateId === id ? resume.format : null);
    open(path, {format:["A6", "A5", "A4"].includes(restoredFormat) ? restoredFormat : saved?.format || "A5", pending:false, sent:false, failed:false,
      image:image?.currentSrc || image?.src || selected.dataset.imgSrc || selected.dataset.front,
      ratio:(image?.naturalWidth || image?.width || 190) / (image?.naturalHeight || image?.height || 297),
      title:image?.alt || selected.querySelector(".addon-section__tab--product-title")?.textContent || config.title});
    frame.dataset.templateId = id;
    frame.dataset.navigationId = crypto.randomUUID();
    syncFrameNavigation();
  }
  const cardProperties = (card) => ({
    _bs_card_draft: card.draftId,
    _bs_card_revision: card.revisionId,
    _bs_card_format: card.format,
    _bs_card_template: cardProducts.resolve(card.templateId)?.templateId || card.templateId,
  });
  const validCard = (card) => card && /^[a-f0-9-]{36}$/.test(card.draftId) &&
    /^[a-f0-9-]{36}-\d+$/.test(card.revisionId) && ["A6", "A5", "A4"].includes(card.format);
  async function cartRequest(path = ".js", body) {
    const response = await fetch((window.Shopify?.routes?.root || "/") + "cart" + path, {
      method: body ? "POST" : "GET",
      cache: "no-store",
      headers: { "Content-Type": "application/json" },
      ...(body ? {body: JSON.stringify(body)} : {}),
      signal: AbortSignal.timeout(15000),
    });
    if (!response.ok) throw new Error("Je winkelwagen kon niet worden bijgewerkt. Probeer het opnieuw.");
    const cart = await response.json();
    if (!Array.isArray(cart.items)) throw new Error("Je winkelwagen kon niet worden gelezen. Probeer het opnieuw.");
    return cart;
  }
  function cartNotice(message, wizard) {
    let notice = document.getElementById("kaartstudio-cart-notice");
    if (!notice) {
      notice = document.createElement("p");
      notice.id = "kaartstudio-cart-notice";
      notice.setAttribute("role", "alert");
      notice.className = "alert alert--error";
      notice.tabIndex = -1;
      notice.style.cssText = "width:100%;flex:0 0 100%;margin:0;padding:10px 14px;font-size:14px;line-height:1.45;overflow-wrap:anywhere;color:#8f3226;background:#fff4f0;border:1px solid #e8b8ac;border-radius:8px";
    }
    const actions = wizard?.querySelector(".id-wizard-final-submit")?.parentElement;
    const host = actions || document.querySelector("#main") || document.body;
    if (actions) actions.style.flexWrap = "wrap";
    host.prepend(notice);
    notice.textContent = message;
    notice.focus({preventScroll: true});
  }
  async function viewCartCard(button) {
    if (button.dataset.cardLoading === "true") return;
    button.dataset.cardLoading = "true";
    button.setAttribute("aria-busy", "true");
    try {
      const cart = await cartRequest();
      const line = cart.items.find((item) => item.key === button.dataset.key);
      if (!line) throw new Error("Deze kaart staat niet meer in je winkelwagen. Vernieuw de pagina.");
      const props = line.properties || {};
      const revision = props._bs_card_revision;
      // Older cards have no design reference. Offer the matching saved design
      // for explicit confirmation, never silently attach a guessed design.
      const saved = cardDrafts.get(String(line.variant_id));
      if (!revision && !validCard(saved)) {
        button.dataset.cardNative = "true";
        button.click();
        delete button.dataset.cardNative;
        return;
      }
      if (revision && !/^[a-f0-9-]{36}-\d+$/.test(revision))
        throw new Error("Het kaartontwerp kon niet worden geopend. Probeer het opnieuw.");
      activeWizard = null;
      activeTemplate = null;
      cartTarget = {key: line.key, uid: props._uid, variantId: line.variant_id,
        revisionId: revision || null, templateId: props._bs_card_template || String(line.variant_id)};
      const params = new URLSearchParams({parent: location.origin, revision: revision || saved.revisionId});
      if (!revision) params.set("recover", "1");
      open("/card?" + params);
    } catch (error) {
      cartNotice(error.message);
    } finally {
      delete button.dataset.cardLoading;
      button.removeAttribute("aria-busy");
    }
  }
  async function saveCartCard(data) {
    if (cartSaving || !cartTarget) return;
    cartSaving = true;
    const target = {...cartTarget};
    const reply = (type, details = {}) => frame.contentWindow.postMessage(
      {type, loadId: frame.dataset.loadId, ...details}, config.origin);
    const sameLine = (line) => line.variant_id === target.variantId &&
      line.properties?._uid === target.uid;
    const alreadySaved = (cart) => cart.items.some((line) => sameLine(line) &&
      line.properties?._bs_card_revision === data.revisionId &&
      line.properties?._bs_card_draft === data.draftId);
    try {
      const product = cardProducts.resolve(target.variantId);
      if (product && Object.values(product.variants).some(v => v.id === String(target.variantId))) {
        cardProducts.assertPurchasable(product);
        if (product.variants[data.format]?.id !== String(target.variantId)) throw new Error(config.changeFormat);
      }
      const cart = await cartRequest();
      if (!alreadySaved(cart)) {
        const line = cart.items.find((item) => item.key === target.key && sameLine(item));
        if (!line || (line.properties?._bs_card_revision || null) !== target.revisionId)
          throw new Error("Deze kaart is intussen gewijzigd of verwijderd. Sluit de kaart en vernieuw je winkelwagen.");
        const body = {id: line.key, quantity: line.quantity,
          properties: {...line.properties, ...cardProperties({...data, templateId: target.templateId})}};
        try {
          const updated = await cartRequest("/change.js", body);
          if (!alreadySaved(updated)) throw new Error("De kaart is nog niet aan je winkelwagen gekoppeld. Probeer opnieuw.");
        } catch (error) {
          // A lost response may still have committed. Read back before retrying.
          const verified = await cartRequest();
          if (!alreadySaved(verified)) throw error;
        }
      }
      reply("ballonnenshop:kaart-gekoppeld");
      close();
      location.reload();
    } catch (error) {
      reply("ballonnenshop:kaart-koppelfout", {message: error.message});
    } finally {
      cartSaving = false;
    }
  }

  document.addEventListener(
    "submit",
    (event) => {
      const form = event.target;
      if (
        form instanceof HTMLFormElement &&
        (checkoutRequest(form.action) || config.checkoutEnabled !== true && event.submitter?.name === "checkout")
      ) {
        event.preventDefault();
        event.stopImmediatePropagation();
        alert(config.blocked);
      }
    },
    true,
  );
  document.addEventListener(
    "click",
    (event) => {
      const target = event.target instanceof Element ? event.target : null;
      if (!target) return;
      const back = target.closest(".global-header-terug-btn");
      if (back && overlay && !overlay.hidden) {
        event.preventDefault();
        event.stopImmediatePropagation();
        if (sizeChoice || overlay.classList.contains("is-loading")) {
          close();
          activeWizard?.updateWizardUI();
        } else
          frame.contentWindow.postMessage(
            { type: "ballonnenshop:vorige" },
            config.origin,
          );
        return;
      }
      const cardButton = target.closest(".card-bekijken-link[data-key]");
      if (cardButton && cardButton.dataset.cardNative !== "true") {
        event.preventDefault();
        event.stopImmediatePropagation();
        void viewCartCard(cardButton);
        return;
      }
      const link = target.closest("a[href]");
      if (config.checkoutEnabled !== true && link && /\/checkout(?:[/?]|$)/.test(link.getAttribute("href"))) {
        event.preventDefault();
        event.stopImmediatePropagation();
        alert(config.blocked);
      }
    },
    true,
  );
  document.addEventListener("click", (event) => {
    const target = event.target instanceof Element ? event.target : null;
    if (!target || target.closest(".rao-zoom-btn,zoom-modal-trigger")) return;
    const card = target.closest('.addon-section--tab[data-index="0"] .addon-section__tab--product.selected');
    const wizard = card?.closest("addon-section");
    const id = card?.querySelector('input[name="id"]')?.value;
    if (!id || !wizard || wizard.currentStep !== 0 || wizard.isTextStepActive ||
        !wizard.pendingSelectionTimer) return;
    // Keep the original selection/cart logic, but remove its 400 ms pause for cards.
    wizard.clearPendingSelection();
    wizard.completeCurrentStep("selected", {option_group:wizard.getOptionGroup(), option_variant_id:id});
    wizard.goToStep(0, true);
  });
  window.addEventListener("message", (event) => {
    if (
      event.origin !== config.origin ||
      event.source !== frame?.contentWindow ||
      !event.data ||
      typeof event.data !== "object"
    )
      return;
    if (
      event.data.type === "ballonnenshop:frame-ready" &&
      event.data.loadId === frame.dataset.loadId
    ) {
      frame.dataset.ready = "true";
      clearTimeout(loadingTimer);
      loading.hidden = !sizeChoice?.pending;
      overlay.classList.remove("is-loading");
      overlay.setAttribute("aria-busy", String(!!sizeChoice?.pending));
      if (!sizeChoice) frame.removeAttribute("aria-hidden");
      sendChoice();
      if (!sizeChoice?.pending) syncFrameNavigation();
      fit();
      return;
    }
    if (event.data.loadId === frame.dataset.loadId && sizeChoice) {
      if (event.data.type === "ballonnenshop:editor-error") {
        choiceFailed(event.data.reload === true);
        return;
      }
      if (event.data.type === "ballonnenshop:editor-open" && sizeChoice.pending &&
          event.data.format === sizeChoice.format && !overlay.hidden) {
        clearTimeout(choiceTimer);
        if (activeTemplate) {
          cardDrafts.set(activeTemplate, {...cardDrafts.get(activeTemplate), format:event.data.format});
          rememberCards();
        }
        sizeChoice = null;
        loading.hidden = true;
        overlay.setAttribute("aria-busy", "false");
        sizePopup.hidden = true;
        overlay.classList.remove("has-size-popup");
        frame.inert = false;
        frame.removeAttribute("aria-hidden");
        frame.dataset.stage = "edit";
        fullscreen(true);
        rememberScreen("edit");
        frame.dataset.navigationId = crypto.randomUUID();
        syncFrameNavigation();
        frame.focus();
        return;
      }
    }
    if (event.data.type === "ballonnenshop:kaart-voorkant") {
      const route = cardRoute();
      if (event.data.loadId !== frame.dataset.loadId ||
          event.data.navigationId !== frame.dataset.navigationId || route?.face !== 0) return;
      // Consume the cover request after the editor applies it, so ordinary
      // reloads retain the page the customer subsequently chooses to edit.
      const {face: requestedFace, ...rest} = route;
      history.replaceState({...history.state, kaartstudio:rest}, "");
      return;
    }
    if (event.data.type === "ballonnenshop:kaart-stap") {
      if (
        event.data.loadId !== frame.dataset.loadId ||
        !["size", "edit", "review", "saved"].includes(event.data.stage)
      )
        return;
      // Startup briefly reports size while the saved draft is loading. Keep
      // the resumed editor full screen throughout that asynchronous load.
      if (frame.dataset.resuming === "true" && event.data.stage === "size") return;
      frame.dataset.resuming = "false";
      frame.dataset.stage = event.data.stage;
      if (cartTarget && event.data.stage === "size") return;
      if (!sizeChoice) fullscreen(cartTarget ? event.data.stage === "edit" : event.data.stage !== "size");
      const label = document.querySelector("#id-active-step-name");
      if (label && activeWizard)
        label.textContent =
          event.data.stage === "size"
            ? "Kaartformaat"
            : event.data.stage === "review"
              ? "Kaart bekijken"
              : "Kaart maken";
      fit();
      return;
    }
    if (event.data.type === "ballonnenshop:kaart-navigatie" &&
        event.data.loadId === frame.dataset.loadId && !cartTarget && !overlay.hidden && cardRoute()) {
      if (event.data.action === "back") previousCardScreen();
      else if (event.data.action === "review" && cardRoute().screen === "edit") {
        rememberScreen("review");
        frame.dataset.stage = "review";
        frame.dataset.navigationId = crypto.randomUUID();
        syncFrameNavigation();
      }
      return;
    }
    if (event.data.type === "ballonnenshop:kaart-gewijzigd" &&
        event.data.loadId === frame.dataset.loadId && !cartTarget && activeTemplate) {
      const card = cardDrafts.get(activeTemplate);
      if (card?.revisionId && card.draftId === event.data.draftId) {
        cardDrafts.set(activeTemplate, {...card, needsConfirmation:true});
        rememberCards();
      }
      return;
    }
    if (
      event.data.type === "ballonnenshop:kaart-concept" &&
      event.data.loadId === frame.dataset.loadId &&
      activeTemplate &&
      /^[a-f0-9-]{36}$/.test(event.data.draftId)
    ) {
      cardDrafts.set(activeTemplate, {
        ...cardDrafts.get(activeTemplate),
        draftId: event.data.draftId,
      });
      rememberCards();
      activeWizard?.saveReturnState();
      return;
    }
    if (
      event.data.type === "ballonnenshop:kaart-sluiten" &&
      event.data.loadId === frame.dataset.loadId
    ) {
      close();
      activeWizard?.goToStep(0, false);
      return;
    }
    if (event.data.type === "ballonnenshop:kaart-terug") {
      activeWizard?.goToStep(0, false);
      return;
    }
    if (event.data.type !== "ballonnenshop:kaart-bewaard" ||
        event.data.loadId !== frame.dataset.loadId) return;
    if (cartTarget && validCard(event.data)) {
      void saveCartCard(event.data);
      return;
    }
    if (!activeWizard || !activeTemplate || overlay.hidden ||
        cardRoute() && (cardRoute().screen !== "review" ||
          event.data.navigationId !== frame.dataset.navigationId)) return;
    const data = event.data;
    if (
      !/^[a-f0-9-]{36}$/.test(data.draftId) ||
      !/^[a-f0-9-]{36}-\d+$/.test(data.revisionId) ||
      !["A6", "A5", "A4"].includes(data.format)
    )
      return;
    const prices = { A6: 345, A5: 445, A4: 545 };
    completed = {
      draftId: data.draftId,
      revisionId: data.revisionId,
      format: data.format,
      templateId: activeTemplate,
      price: cardProducts.resolve(activeTemplate)?.variants[data.format]?.price || prices[data.format],
    };
    cardDrafts.set(activeTemplate, completed);
    rememberCards();
    const row = activeWizard?.cart.querySelector(
      '.addon-section__cart--product[data-index="0"]',
    );
    if (row) {
      const old = Number(row.dataset.price || 0);
      row.dataset.price = String(completed.price);
      row.dataset.cardRevisionId = data.revisionId;
      row.dataset.cardDraftId = data.draftId;
      row.dataset.cardFormat = data.format;
      try {
        activeWizard.totalCalculator.decrease(old);
        activeWizard.totalCalculator.increase(completed.price);
      } catch {}
    }
    close();
    activeWizard.goToStep(1, false);
  });
  customElements.whenDefined("addon-section").then(() => {
    const proto = customElements.get("addon-section").prototype;
    if (proto.__kaartstudioInstalled) return;
    proto.__kaartstudioInstalled = true;
    const snapshot = proto.createReturnState;
    proto.createReturnState = function () {
      const state = snapshot.apply(this, arguments);
      if (this.kaartstudioResume) state.kaartstudio = this.kaartstudioResume;
      if (this === activeWizard && this.currentStep === 0 && this.isTextStepActive && !overlay?.hidden) {
        state.kaartstudio = {
          templateId: activeTemplate,
          screen: cardRoute()?.screen || (sizeChoice ? "size" : frame.dataset.stage === "review" ? "review" : "edit"),
          format: sizeChoice?.format || cardDrafts.get(activeTemplate)?.format || "A5",
        };
      }
      return state;
    };
    const restore = proto.restoreReturnState;
    proto.restoreReturnState = function (state) {
      const restored = restore.apply(this, arguments);
      if (!restored) return false;
      this.kaartstudioResume = state.kaartstudio;
      const selectedId = this.tabs[0]?.querySelector('.selected input[name="id"]')?.value;
      const card = cardDrafts.get(selectedId);
      const row = this.cart.querySelector('.addon-section__cart--product[data-index="0"]');
      if (row && validCard(card)) {
        const old = Number(row.dataset.price || 0);
        const price = cardProducts.resolve(selectedId)?.variants[card.format]?.price || {A6:345, A5:445, A4:545}[card.format];
        row.dataset.price = String(price);
        row.dataset.cardDraftId = card.draftId;
        row.dataset.cardRevisionId = card.revisionId;
        row.dataset.cardFormat = card.format;
        this.totalCalculator.decrease(old);
        this.totalCalculator.increase(price);
      }
      return true;
    };
    const scrollWizardToTop = proto.scrollWizardToTop;
    proto.scrollWizardToTop = function () {
      const view = pendingGridReturn;
      if (!view || view.wizard !== this || this.currentStep !== 0 || this.isTextStepActive)
        return scrollWizardToTop.apply(this, arguments);
      pendingGridReturn = null;
      const restore = () => {
        // Stop if the customer has opened another card or moved to another step.
        if (cardGridViews.get(this) !== view || this.currentStep !== 0 ||
            this.isTextStepActive || !overlay?.hidden) return;
        for (const {element, left, top} of view.containers) {
          if (element.isConnected) element.scrollTo({left, top, behavior:"instant"});
        }
        window.scrollTo({left:view.left, top:view.top, behavior:"instant"});
      };
      restore();
      requestAnimationFrame(restore);
      setTimeout(restore, 80);
      setTimeout(restore, 250);
    };
    const goToStep = proto.goToStep;
    proto.goToStep = function (step, textActive = false) {
      const id = this.tabs[0]?.querySelector('.selected input[name="id"]')?.value;
      // Returning to a completed card step reopens the confirmed design.
      // Skipping clears the selection, so that route still shows the catalogue.
      const resumeCard = step === 0 && !textActive && this.currentStep > 0 &&
        validCard(cardDrafts.get(id));
      if (step !== 0 || (!textActive && !resumeCard)) return goToStep.apply(this, arguments);
      if (this.currentStep === 0 && !this.isTextStepActive) {
        const containers = [];
        for (let element = this.parentElement; element; element = element.parentElement) {
          if (element !== document.scrollingElement && (element.scrollTop || element.scrollLeft))
            containers.push({element, left:element.scrollLeft, top:element.scrollTop});
        }
        cardGridViews.set(this, {wizard:this, left:window.scrollX, top:window.scrollY, containers});
      }
      this.clearPendingSelection();
      this.currentStep = 0;
      this.isTextStepActive = true;
      history.pushState({step:0, textActive:true,
        kaartstudio:{version:1, templateId:id, screen:resumeCard ? "edit" : "size",
          ...(resumeCard ? {face:0} : {}), format:cardDrafts.get(id)?.format || "A5"}}, "");
      // Opening a dialog does not require hiding and scrolling the card grid.
      openStudio(this);
      this.emitStepView();
      this.saveReturnState();
    };
    const update = proto.updateWizardUI;
    proto.updateWizardUI = function () {
      const selectedId = this.tabs[0]?.querySelector('.selected input[name="id"]')?.value;
      if (this.currentStep === 1 && cardDrafts.get(selectedId)?.needsConfirmation) {
        // Forward after editing must confirm the new document, just like the
        // green button. Revisit the existing review entry; preflight stays active.
        forwardConfirmation = selectedId;
        history.back();
        return;
      }
      const returningToGrid = this === activeWizard && overlay && !overlay.hidden &&
        this.currentStep === 0 && !this.isTextStepActive ? cardGridViews.get(this) : null;
      const result = update.apply(this, arguments);
      if (this.currentStep === 0 && this.isTextStepActive) openStudio(this);
      else close();
      if (returningToGrid) pendingGridReturn = returningToGrid;
      this.saveReturnState();
      return result;
    };
    const sync = proto.syncConfiguratorCart;
    proto.syncConfiguratorCart = async function (items) {
      document.getElementById("kaartstudio-cart-notice")?.remove();
      const selectedId = this.tabs[0]?.querySelector(
        '.addon-section__tab--product.selected input[name="id"]')?.value;
      const card = cardDrafts.get(selectedId);
      try {
        const personalized = items.map(item => {
          if (String(item.id) !== selectedId || !item.properties?._addon) return item;
          if (!validCard(card) || card.needsConfirmation) throw new Error(config.confirmDesign);
          return cardProducts.mapLine({...item, properties: {...item.properties, ...cardProperties(card)}}, card.format);
        });
        return await sync.call(this, personalized);
      } catch (error) {
        const publicMessages = [config.draftProduct, config.missingProduct, config.confirmDesign];
        cartNotice(publicMessages.includes(error.message) ? error.message : config.cartError, this);
        throw error;
      }
    };
    // Save selections during use as well as pagehide (which mobile browsers may
    // omit when a background tab is discarded). No cart request is performed.
    let saveTimer;
    const saveActive = () => document.querySelector("addon-section")?.saveReturnState();
    document.addEventListener("visibilitychange", () => {
      if (document.visibilityState === "hidden") saveActive();
    });
    for (const type of ["input", "change", "click"]) document.addEventListener(type, event => {
      if (!event.target?.closest?.("addon-section")) return;
      clearTimeout(saveTimer);
      saveTimer = setTimeout(saveActive, 100);
    });
    const restoreReload = () => {
      if (performance.getEntriesByType("navigation")[0]?.type !== "reload") return;
      // The shared live controller already restores history/selection snapshots
      // on Back. Reuse that same path for reloads, only inside this concept.
      const controller = customElements.get("addon-section");
      const state = controller.readReturnState();
      if (controller.getHistoryStep()?.textActive && !cardRoute() &&
          (!state || state.path !== location.pathname || !Array.isArray(state.options) ||
            !state.options.some(option => option?.index === 0))) {
        history.replaceState({...history.state, textActive:false}, "");
      }
      controller.restoreFromHistory({type:"pageshow", persisted:true});
    };
    if (document.readyState === "complete") restoreReload();
    else window.addEventListener("pageshow", restoreReload, {once:true});
  });
  // The original Shopify cart owns /cart, its navigation and its appearance.
  // Never mount the standalone basket here, including after a reload.
})();
